import { AppViewMode } from 'src/constants';
import { ProductStoreClientPage } from 'src/routes/billing/store/client/page';
import { ProductStorePage } from 'src/routes/billing/store/page';
import { RouteAction } from 'src/routes/types';

const action: RouteAction = (context) => {
  return {
    chunks: ['store'],
    title: 'Store',
    component:
      context.portalConfig.viewMode === AppViewMode.INTERNAL ? (
        <ProductStorePage />
      ) : (
        <ProductStoreClientPage />
      ),
  };
};

export default action;
